import { Controller } from "@hotwired/stimulus"
import tomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    allowBlank: { type: Boolean, default: false },
    enableControlInput: { type: Boolean, default: false }
  }
  connect() {
    const plugins = ['input_autogrow'];

    // Add remove_button plugin for multiple select
    if (this.element.hasAttribute('multiple')) {
      plugins.push('remove_button');
    }

    const options = {
      allowEmptyOption: this.allowBlankValue,
      create: true,
      plugins: plugins
    };

    if (!this.enableControlInputValue) {
      options.controlInput = null;
    }

    new tomSelect(this.element, options);
  }
}
